<template>
  <tr class="divide-x">
    <td class="px-4 text-sm font-medium">{{ label }}</td>
    <td class="px-3 py-2">
      <input
        type="checkbox"
        :checked="valueInput === -1"
        @change="setUnlimited($event.target.checked)"
      />
    </td>
    <td class="p-0 text-right text-xs">
      <input
        v-if="valueInput !== -1"
        type="number"
        v-model="valueInput"
        min="1"
        step="1"
        class="input-number-appearance-none py-2 pl-4 pr-3 sm:pl-6 text-sm text-slate-900 text-right w-full focus:outline-none focus:ring-1 focus:ring-slate-900 focus:z-10"
      />
      <span v-else class="inline-block px-3 py-2">Unlimited</span>
    </td>
    <td class="p-0">
      <div class="relative focus-within:z-10">
        <input
          type="number"
          v-model="unitAmountInput"
          min="0"
          step="0.01"
          class="input-number-appearance-none relative pl-3 pr-10 py-2 text-sm text-slate-900 text-right w-full focus:outline-none focus:ring-1 focus:ring-slate-900"
        />
        <span
          class="absolute flex items-center justify-center right-0 top-0 bottom-0 w-8 bg-slate-50 text-slate-600 text-sm"
          >&euro;</span
        >
      </div>
    </td>
    <td class="p-0">
      <div class="relative focus-within:z-10">
        <input
          type="number"
          v-model="flatAmountInput"
          min="0"
          step="0.01"
          class="input-number-appearance-none relative pl-3 pr-10 py-2 text-sm text-slate-900 text-right w-full focus:outline-none focus:ring-1 focus:ring-slate-900"
        />
        <span
          class="absolute flex items-center justify-center right-0 top-0 bottom-0 w-8 bg-slate-50 text-slate-600 text-sm"
          >&euro;</span
        >
      </div>
    </td>
    <td class="p-0">
      <select
        v-model="resettablePeriodInput"
        class="relative px-3 py-2 text-sm text-slate-900 text-right w-full focus:outline-none focus:ring-1 focus:ring-slate-900 focus:z-10 appearance-none"
      >
        <option value="lifetime">Lifetime</option>
        <option value="month">Month</option>
        <option value="year">Year</option>
      </select>
    </td>
    <td class="p-0 w-48">
      <select
        class="relative px-3 py-2 text-sm text-slate-900 text-right w-full focus:outline-none focus:ring-1 focus:ring-slate-900 focus:z-10 appearance-none"
        v-model="currentPreset"
        @change="handlePresetChange"
      >
        <option :value="null">Select preset</option>
        <option v-for="(option, optionIdx) in priceOptions" :key="optionIdx" :value="option.value">
          <span>{{ option.label }}</span>
        </option>
      </select>
    </td>
  </tr>
</template>

<script>
import numbro from '@/utils/numbro';

export default {
  props: {
    label: {
      type: String,
      default: 'Option label',
    },
    pricePresets: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentPreset: null,
    };
  },
  computed: {
    priceOptions() {
      return this.pricePresets.map((preset) => {
        const price = (preset.value * preset.unit_amount + preset.flat_amount) / 100;
        const displayPrice = price
          ? `${numbro(price).format({
              thousandSeparated: true,
              mantissa: 2,
            })}\u20AC`
          : 'free';
        const displayValue = numbro(preset.value).format({
          thousandSeparated: true,
        });

        return {
          value: preset,
          label:
            preset.resettable_period === 'lifetime'
              ? `${displayValue} for ${displayPrice}`
              : `${displayValue}/${preset.resettable_period} for ${displayPrice}`,
        };
      });
    },
    valueInput: {
      get() {
        return this.item.value;
      },
      set(value) {
        this.update('value', Number.parseInt(value));
      },
    },
    unitAmountInput: {
      get() {
        return this.item.unit_amount / 100;
      },
      set(value) {
        this.update('unit_amount', Number.parseInt(value * 100));
      },
    },
    flatAmountInput: {
      get() {
        return this.item.flat_amount / 100;
      },
      set(value) {
        this.update('flat_amount', Number.parseInt(value * 100));
      },
    },
    resettablePeriodInput: {
      get() {
        return this.item.resettable_period;
      },
      set(value) {
        this.update('resettable_period', value);
      },
    },
  },
  methods: {
    setFromPreset(ev) {
      console.log(ev.target.value);
    },
    handlePresetChange() {
      if (!this.currentPreset) {
        return;
      }

      this.$emit('change', {
        ...this.item,
        value: this.currentPreset.value,
        unit_amount: this.currentPreset.unit_amount,
        flat_amount: this.currentPreset.flat_amount,
        resettable_period: this.currentPreset.resettable_period,
      });

      this.currentPreset = null;
    },
    update(key, value) {
      this.$emit('change', {
        ...this.item,
        [key]: value,
      });
    },
    setUnlimited(checked) {
      this.valueInput = checked ? -1 : 1;
    },
  },
};
</script>

<style scoped>
.input-number-appearance-none::-webkit-outer-spin-button,
.input-number-appearance-none::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}
</style>
